import React, { useEffect, useState } from 'react';
import {
	Card,
	CardContent,
	Typography,
	Stack,
	Button,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	CircularProgress,
} from '@mui/material';
import { AppColors } from '../../../../../../Utils/helper/AppColors';

const SelectModelCard = ({ onBack, onSelect, models = [], loading }) => {
	const [selectedModel, setSelectedModel] = useState('');
	const [modalAllInfo, setModelAllInfo] = useState(null);
	const [error, setError] = useState('');

	useEffect(() => {
		if (!!selectedModel) {
			let seletedAssistent = models.find((model) => model.value === selectedModel);
			setModelAllInfo(seletedAssistent);
		}
	}, [selectedModel]);

	const handleSubmit = () => {
		if (!selectedModel) {
			setError('Please select an assistant to continue');
			return;
		}
		onSelect(selectedModel);
	};

	return (
		<Card
			sx={{
				borderRadius: 3,
				boxShadow: 2,
				width: '100%',
				height: { xs: 'auto' },
				maxWidth: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				px: { xs: 1, md: 3 },
			}}
		>
			<CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
				<Typography sx={{ fontWeight: 700, fontSize: { sm: '24px', md: '32px' } }} mb={{ sm: 1, md: 2 }}>
					Who do you want to speak?
				</Typography>

				{loading ? (
					<Stack alignItems="center" justifyContent="center" my={4}>
						<CircularProgress />
						{/* <Typography variant="body2" mt={2}>Loading available assistants...</Typography> */}
					</Stack>
				) : models.length === 0 ? (
					<Typography color="error" mb={3}>
						No assistants are currently available.
					</Typography>
				) : (
					<Stack>
						<Typography sx={{ fontWeight: 400, fontSize: { sm: '16px', md: '18px' }, color: AppColors?.grey_text, mb: 2 }}>
							Please select an assistant to continue.
						</Typography>
						<FormControl fullWidth sx={{ mb: 3 }}>
							<InputLabel id="model-select-label">Select Assistant</InputLabel>
							<Select
								labelId="model-select-label"
								value={selectedModel}
								label="Select Assistant"
								onChange={(e) => {
									setSelectedModel(e.target.value);
									setError('');
								}}
								error={!!error}
								  sx={{  height: { sm: 40, md: 50 }, width : {xs : '84vw', sm : '100%' , md : '100%'} }}
							>
								{models.map((model) => (
									<MenuItem key={model.value} value={model.value}
									    
									>
										{model.label}
									</MenuItem>
								))}
							</Select>

							{modalAllInfo && (
    <Card
        sx={{
            mt: 3,
            p: 2,
            borderRadius: 2,
            boxShadow: 1,
            backgroundColor: AppColors?.bg_gray,
            border: '1px solid #ddd',
        }}
    >
        <Typography
            sx={{
                fontWeight: 600,
                fontSize: { sm: '16px', md: '18px' },
                color: '#333',
                mb: 2,
				textAlign : {xs : 'center', md : 'left'},
				width : '100%',
            }}
        >
            Selected Model Information
        </Typography>

        {/* Short Description */}
        <Stack sx={{flexDirection : {xs : 'column', md : 'row'}}} spacing={{  xs : 0.4,md : 1}} mb={1}>
            <Typography
                sx={{
                    fontWeight: 500,
                    fontSize: { xs: '14px', md: '16px' },
                    // color: '',
                    minWidth: '120px',
                }}
            >
                Summary:
            </Typography>
            <Typography
                sx={{
                    fontWeight: 400,
                    fontSize: { xs: '14px', md: '16px' },
                    color: AppColors?.grey_text,
					 mt: '0 !important',
                }}
            >
                {modalAllInfo?.details?.shortDescription || 'N/A'}
            </Typography>
        </Stack>

        {/* Long Description */}
        <Stack sx={{ flexDirection: { xs: 'column', md: 'row' } }} spacing={1}>
            <Typography
                sx={{
                    fontWeight: 500,
                    fontSize: { xs: '14px', md: '16px' },
                    // color: '#555',
                    minWidth: '120px',

                }}
            >
                Details:
            </Typography>
            <Stack
                className="ql-editor"
				style={{padding: 0 , margin: 0}}
            >
                <div style={{padding: 0 , margin: 0}} dangerouslySetInnerHTML={{ __html: modalAllInfo?.details?.longDescription || 'N/A' }} />
            </Stack>
        </Stack>
    </Card>
)}

							{error && (
								<Typography color="error" variant="caption" mt={1}>
									{error}
								</Typography>
							)}
						</FormControl>
					</Stack>
				)}

				<Stack direction="row-reverse">
					{/* <Button 
            variant="outlined" 
            onClick={onBack}
            disabled={loading}
          >
            Back
          </Button> */}
					<Button
						variant="contained"
						color="info"
						sx={{
							width: '150px',
						}}
						onClick={handleSubmit}
						disabled={loading || !models.length || !selectedModel}
					>
						Next
					</Button>
				</Stack>
			</CardContent>
		</Card>
	);
};

export default SelectModelCard;
